import React from "react";
import { Breadcrumb } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Routes } from "../../../routes";
import { useParams } from "react-router-dom";

import FormPermissions from './FormPermissions'
import Form from './Form'

const Component = () => {
    let { _settingId } = useParams();

    // this form has no predefined init state
    const item = {}

    return (
        <>
            <div className="d-lg-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="mb-4 mb-lg-0">
                    <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                        <Breadcrumb.Item href={Routes.Dashboard.path}><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item>Settings</Breadcrumb.Item>
                        <Breadcrumb.Item href={Routes.EarningSettings.path}>Points</Breadcrumb.Item>
                        <Breadcrumb.Item href={Routes.EarningSetting.path.replace(':_id', _settingId)}>Earning method</Breadcrumb.Item>
                        <Breadcrumb.Item active>Create additional actions</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Create additional action</h4>
                </div>
            </div>
            <FormPermissions>
                <Form item={{...item, ...{ earningSetting: _settingId}}} />
            </FormPermissions>
        </>
    );
};

export default Component;
